<template>
  <transition name="order-form">
    <div class="order-form-mask">
      <div class="order-form">
        <div class="contact-info-form">
          <div>姓名</div>
          <input placeholder="必填" type="text" v-model="name"></input>
          <div>電話</div>
          <input placeholder="必填" type="tel" v-model="tel"></input>
          <div>電子郵件</div>
          <input type="email" v-model="email"></input>
          <div>備註</div>
          <textarea v-model="notes"></textarea>
        </div><!--
        --><div class="product-summary">
          <div class="available-components">
            <div v-for="type in availableComponents">
              <div><b>{{ type.title }}</b></div>
              <div class="info-item" v-for="component in type.components" v-if="component.price > 0">
                <div class="info-item-title">{{ component.info }}</div>
                <div class="info-item-text">$ {{ component.price | priceTag  }}</div>
              </div>
            </div>
          </div>
          <div class="price-summary">
            <div class="info-item">
              <div class="info-item-title">單價</div>
              <div class="info-item-text">NT$ {{ productPrice | priceTag }}</div>
            </div>
            <div class="info-item">
              <div class="info-item-title">數量</div>
              <input class="info-item-text" type="number" min="1" v-model="productCount"></input>
            </div>
            <div class="info-item">
              <div class="info-item-title">總價</div>
              <div class="info-item-text">NT$ {{ totalPrice | priceTag }}</div>
            </div>
          </div>
          <div class="navigation-buttons">
            <span class="cancel-btn" v-on:click="cancel">取消</span>
            <span class="confirm-btn" v-on:click="confirm">確認訂購</span>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import Utils from 'utils/utils';

let cachedName = '';
let cachedTel = '';
let cachedEmail = '';
let cachedNotes = '';
let cachedProductCount = 1;

function getTotalPriceOfComponentsOfType(productSummary, type) {
  const components = productSummary.components[type].components;
  return components.reduce((totalPrice, component) => {
    return totalPrice + component.price;
  }, 0);
}

export default {
  name: 'order-form',
  props: ['productSummary'],
  data() {
    return {
      name: cachedName,
      tel: cachedTel,
      email: cachedEmail,
      notes: cachedNotes,
      productCount: cachedProductCount
    };
  },
  computed: {
    availableComponents() {
      if (!this.productSummary || !this.productSummary.components) {
        return [];
      }
      return Object.keys(this.productSummary.components).filter((type) => {
        return getTotalPriceOfComponentsOfType(this.productSummary, type) > 0;
      }).map((type) => {
        return this.productSummary.components[type];
      });
    },
    productPrice() {
      if (!this.productSummary || !this.productSummary.components) {
        return 0;
      }
      return Object.keys(this.productSummary.components).reduce(
        (price, type) => {
          return getTotalPriceOfComponentsOfType(this.productSummary, type) +
            price;
        }, 0);
    },
    totalPrice() {
      return this.productPrice * this.productCount;
    }
  },
  filters: {
    priceTag: Utils.priceTag
  },
  methods: {
    cancel() {
      this.$emit('cancel');
      this.close();
    },
    confirm() {
      if (!this.name) {
        this.$emit('alert', '請填寫姓名。');
        return;
      }
      if (!this.tel) {
        this.$emit('alert', '請填寫電話。');
        return;
      }

      this.$emit('confirm', this.name, this.tel, this.email, this.notes,
        this.productCount);
      this.close();
    },
    alert(msg) {
      this.$emit('alert', msg);
    },
    close() {
      // cache the information for later use.
      cachedName = this.name;
      cachedTel = this.tel;
      cachedEmail = this.email;
      cachedNotes = this.notes;
      cachedProductCount = this.productCount;

      this.$emit('close');
    }
  }
};
</script>

<style scope>
.order-form-mask {
  position: fixed;
  z-index: 9997;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, .5);
  display: table;
  transition: opacity .3s ease;
}

.order-form {
  margin-top: 20px;
  margin-left: auto;
  margin-right: auto;
  text-align: left;
  width: 650px;
  height: calc(100% - 40px);
  line-height: 32px;
  background-color: #fff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
  -moz-box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
  -webkit-box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
}
.contact-info-form {
  width: 40%;
  height: 100%;
  display: inline-block;
  vertical-align: top;
  box-sizing: border-box;
  padding: 20px;
}
.contact-info-form input, textarea {
  width: 100%;
  border: 1px solid silver;
}
.contact-info-form textarea {
  resize: none;
  height: calc(100% - 289px);
}
.contact-info-form div {
  font-weight: bold;
}
.product-summary {
  width: 60%;
  height: 100%;
  vertical-align: top;
  display: inline-block;
  box-sizing: border-box;
  padding: 20px;
  position: relative;
}
.available-components {
  height: calc(100% - 180px);
  overflow-y: auto;
}
.price-summary {
  height: 120px;
  box-sizing: border-box;
  border-top: 1px silver solid;
  border-bottom: 1px silver solid;
  padding: 10px;
}
.navigation-buttons {
  height: 50px;
  box-sizing: border-box;
  vertical-align: middle;
  padding: 20px 0;
  text-align: right;
  line-height: 22px;
}

.navigation-buttons span {
  color: #6DADAD;
  border: 1px solid #6DADAD;
  background: none;
  display: inline-block;
  padding: 5px 20px;
  border-radius: 5px;
  margin-left: 10px;
  cursor: pointer;
}

.navigation-buttons span:hover {
  background: #6DADAD;
  color: white;
}

.info-item {
  position: relative;
}
.info-item-title {
  text-align: left;
}
.info-item-text {
  position: absolute;
  width: 100%;
  right: 0;
  top: 0;
  text-align: right;
}
input.info-item-text {
  line-height: 24px;
  background: none;
  width: 50px;
  top: 2px;
  border: 1px solid silver;
  font-size: 14px;
}

/*
 * The following styles are auto-applied to elements with
 * transition="order-form" when their visibility is toggled
 * by Vue.js.
 *
 * You can easily play with the modal transition by editing
 * these styles.
 */

.order-form-enter {
  opacity: 0;
}

.order-form-leave-active {
  opacity: 0;
}
</style>


// WEBPACK FOOTER //
// order-form.vue?e4a90930